import { useSelector } from "react-redux";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import useStaticListSizeQuota from "app/pages/sales-intelligence/hooks/useStaticListSizeQuota";
import accountReviewTrackingService from "app/pages/sales-intelligence/sub-modules/account-review/services/tracking/accountReviewTrackingService";
import type { RootState } from "single-spa/store/types";

import { useFetchOpportunityListsIfNotPresent } from "../../opportunities/hooks/useFetchOpportunityListsIfNotPresent";

import type { AddWebsiteToListButtonBaseProps } from "./AddWebsiteToListButton";
import AddWebsiteToListButton from "./AddWebsiteToListButton";
import { selectAlreadyInList, selectDisabledListNames } from "./selectors";

const AddWebsiteToListButtonContainer = ({ onButtonClick, ...props }: AddWebsiteToListButtonBaseProps) => {
    const { isListSizeQuotaReached, limitOfWebsitesToTrack } = useStaticListSizeQuota();
    const canDeleteOpportunities = salesSettingsHelper.canDeleteOpportunities();
    const disabledListsNames = useSelector((state: RootState) => selectDisabledListNames(state, props));
    const listsWithDomain = useSelector((state: RootState) => selectAlreadyInList(state, props));

    useFetchOpportunityListsIfNotPresent();

    const handleButtonClick = () => {
        accountReviewTrackingService.trackAddToListClick(listsWithDomain?.length);

        onButtonClick?.();
    };

    const handleButtonHover = () => {
        accountReviewTrackingService.trackAddToListHover(listsWithDomain?.length);
    };

    return (
        <AddWebsiteToListButton
            {...props}
            onButtonClick={handleButtonClick}
            onButtonHover={handleButtonHover}
            listsWithDomain={listsWithDomain}
            isDisabled={isListSizeQuotaReached}
            disabledListsNames={disabledListsNames}
            isListSizeQuotaReached={isListSizeQuotaReached}
            isTrialTooltip={!canDeleteOpportunities}
            limitOfWebsitesToTrack={limitOfWebsitesToTrack}
        />
    );
};

export default AddWebsiteToListButtonContainer;
